var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRiscaldamento(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, ".cls-1{fill:#09253e;}.cls-1,.cls-2,.cls-4{stroke:#09253e;}.cls-1,.cls-2{stroke-miterlimit:11.34;}.cls-2,.cls-3,.cls-4{fill:#fff;}.cls-4{stroke-miterlimit:10;}"))), /*#__PURE__*/React.createElement("path", {
    id: "path97",
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeDasharray: "none"
    },
    className: "cls-1",
    d: "M 25.349609 7.4101562 L 2.5 27.480469 L 4.5800781 27.480469 L 9.4199219 23.285156 L 9.4199219 43.689453 L 40.580078 43.689453 L 40.580078 23.140625 L 45.419922 27.480469 L 47.5 27.480469 L 39.792969 20.498047 L 39.792969 14.744141 L 37.169922 14.744141 L 37.169922 18.121094 L 25.349609 7.4101562 z "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeDasharray: "none"
    },
    id: "path1",
    cx: 19.777987,
    cy: 36.778996,
    r: 2.0287938
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    style: {
      fillOpacity: 0,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeDasharray: "none"
    },
    d: "m 19.777344,18.238281 c -0.866325,-2.9e-5 -1.654326,0.787972 -1.654297,1.654297 0,0 0,0.002 0,0.002 V 32.97075 a 0.82402667,0.82402667 0 0 1 -0.375,0.691406 c -1.032684,0.672336 -1.689748,1.884925 -1.689453,3.117188 8.2e-5,0.973634 0.40138,1.940443 1.089844,2.628906 0.688463,0.688463 1.655272,1.089761 2.628906,1.089844 0.9739,3.36e-4 1.942059,-0.399387 2.630859,-1.087891 0.6888,-0.688503 1.089761,-1.656959 1.089844,-2.630859 -5.1e-5,-1.232552 -0.658135,-2.445224 -1.691406,-3.117188 a 0.82402667,0.82402667 0 0 1 -0.375,-0.691406 V 19.892578 c 2.9e-5,-0.866325 -0.787972,-1.654326 -1.654297,-1.654297 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeDasharray: "none"
    },
    d: "M 19.777987,34.750202 V 25.253814",
    id: "path3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1",
    transform: "matrix(1.3610423,0,0,1.3610423,-8.5363006,-10.250941)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#09253e",
      strokeWidth: 1.1021,
      strokeLinecap: "square",
      strokeDasharray: "none"
    },
    d: "m 25.66803,24.246815 h 2.435301",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#09253e",
      strokeWidth: 1.1021,
      strokeLinecap: "square",
      strokeDasharray: "none"
    },
    d: "M 29.205428,25.348912 V 27.29168",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#09253e",
      strokeWidth: 1.1021,
      strokeLinecap: "square",
      strokeDasharray: "none"
    },
    d: "M 28.10333,28.393778 H 25.558577",
    id: "path6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#09253e",
      strokeWidth: 1.1021,
      strokeLinecap: "square",
      strokeDasharray: "none"
    },
    d: "m 24.456479,29.495876 v 1.805953",
    id: "path7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#09253e",
      strokeWidth: 1.1021,
      strokeLinecap: "square",
      strokeDasharray: "none"
    },
    d: "m 25.558579,32.403929 h 2.654205",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#09253e",
      strokeWidth: 1.1021,
      strokeLinecap: "square",
      strokeDasharray: "none"
    },
    d: "m 32.170199,29.521723 v 2.852858",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#09253e",
      strokeWidth: 1.1021,
      strokeLinecap: "square",
      strokeDasharray: "none"
    },
    d: "m 32.170199,24.412977 v 2.852858",
    id: "path9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiscaldamento);
export default __webpack_public_path__ + "static/media/riscaldamento.c706dbc7ccaad920c5bdc6b1d256f627.svg";
export { ForwardRef as ReactComponent };